export default __webpack_public_path__ + "static/media/dulces_detail1.07595dca.jpg";